import React, { memo } from "react";
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

const SpeedometerChart = (props) => {
 const {
    chartName,
    chartradius,
    gaugeWidth,
    hideAnchor,
    hidePointer,
    isCenterLabel,
    showColor,
    stylePlace,
    totalValue,
} = props;
   const chartDataInteger = parseInt(props.chartData);
   const getSpeedOption = () => {
    const options = {
      series: [
        {
          type: "gauge",
          radius: chartradius ? chartradius: '95%',
          center: ['50%', '50%'],
            axisLine: {
            lineStyle: {
              width: gaugeWidth ? gaugeWidth :10,
              color: showColor ? showColor : [[0.3, '#ff471a'], [0.7, '#ffbf00'], [1, '#26a65b']],
            },
          },
          anchor: hideAnchor
            ? { show: false }
            : {
              show: true,
              showAbove: true,
              size: 5,
              itemStyle: {
                borderWidth: 2,
                borderColor: "black"
              }
            },
          pointer: hidePointer
            ? { show: false }
            : {
              show: true,
              width: 2,
              length: 50,
              itemStyle: {
                color: 'black',
              },
            },
          axisTick: {
            distance: -30,
            length: 8,
            lineStyle: {
              color: '#fff',
              width: 0,
            },
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: {
              color: '#fff',
              width: 0,
            },
          },
          axisLabel: {
            color: 'black',
            distance: 15,
            fontSize: 0,
          },
          detail: isCenterLabel ? {       
            width: '60%',
            lineHeight: 40,
            borderRadius: 8,
            offsetCenter: [0, '-15%'],
            valueAnimation: true,
            formatter: "{value}%",
            color: 'black',
            fontSize: totalValue ? totalValue:10, }
            :{
            valueAnimation: true,
            formatter: "{value}%",
            color: 'black',
            fontSize: totalValue ? totalValue:10,
          },
           
          data: [
            {
              value: chartDataInteger ? chartDataInteger : 0,
              name: chartName ? chartName :"",
 
             },
          ],
        },
      ],
    };
     return options;
  };

  return (
    <ReactECharts option={getSpeedOption()} style={stylePlace ? stylePlace : false} />
  );
  
};
SpeedometerChart.propTypes = {
  chartName: PropTypes.string,
  chartradius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  gaugeWidth: PropTypes.number,
  hideAnchor: PropTypes.bool,
  hidePointer: PropTypes.bool,
  isCenterLabel: PropTypes.bool,
  showColor: PropTypes.array,
  stylePlace: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  totalValue: PropTypes.number,
  chartData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default memo(SpeedometerChart);



